import React, { useEffect, useMemo, useRef, useState } from "react";
import OffCanvasModal from "../modal/OffCanvasModal/OffCanvasModal";
import "./add-client.scss";
import TextInput from "../common/TextInput";
import locationIcon from "../../images/location_input.svg";
import { ReactComponent as TimeIcon1 } from "../../images/icons/ComplianceTime1.svg";
import { ReactComponent as TimeIcon2 } from "../../images/icons/ComplianceTime2.svg";
import { ReactComponent as GpLogo } from "../../images/icons/gpLogo.svg"
import { ReactComponent as RightArrow } from "../../images/icons/chevron-left.svg";
import CustomModal from "../modal/CustomModal";
import AddNotes from "../common/AddNotes";
import NextOfKin from "./NextOfKin";
import SignatureCanvas from 'react-signature-canvas';
import Autocomplete from "react-google-autocomplete";
import { googleApiKey } from "../../config";
import CustomRadioButton from "../common/CustomRadioButton";
import NavHeader from "../common/NavHeader/NavHeader";
import { useLocation, useNavigate, useParams } from "react-router";
import { getSearchClientRoute } from "../../Routes";

import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';

import PropTypes from 'prop-types'

import { CreateClient } from "../redux/actions/client/CreateClient";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { GetClientDetails } from "../redux/actions/client/GetClientDetails";


import { toast } from "react-toastify";
import { CreateIdentityDocument } from "../redux/actions/client/CreateIdentity";
import StepButton from "../common/StepButton";
import { DeleteIdentityDocument } from "../redux/actions/client/DeleteIdentity";
import { ReactComponent as CloseIcon } from "../../images/close_icon.svg";

import { alphaNumericRegex, alphaNumericRegexAp } from "../../utils/validationRegx";
import { GetNextOfKinDetails } from "../redux/actions/client/GetNextOfKinDetails";
import { GetIdentityDocumentDataQuery } from "../redux/actions/client/GetIdentityData";
import CustomDropdown from "../common/dropdown/CustomDropdown";
import { DeleteProfileImage } from "../redux/actions/client/DeleteClientProfileImage";
import Resizer from "react-image-file-resizer";
import { ReactComponent as EmptySignIcon1 } from "../../images/new-appointment/empty_sign-1.svg";

import useDeviceDetect from "../common/useDeviceDetect";
import EraseImg from '../../images/new-appointment/erase.png';
import { ReactComponent as UndoEnableIcon } from '../../images/new-appointment/undo_enable.svg';
import { ReactComponent as UndoIcon } from '../../images/new-appointment/undo.svg';
import { ReactComponent as EnableCheck } from '../../images/new-appointment/enable_check.svg';
import CustomeHeading from "../customeHeading/customeHeading";
import { SaveClientMedicalFormDetailsAction } from "../redux/actions/medicalForm/saveClientMedicalFormDetails"
import { GetClientMedicalFormDetailsAction } from "../redux/actions/medicalForm/getClientMedicalFormDetails"
import { SaveMedicalPractitinorDetailAction } from "../redux/actions/medicalForm/saveMedicalFormPractitionerDetails"
import { GetMedicalPractitinorDetailAction } from "../redux/actions/medicalForm/getMedicalFormPractitionerDetails"
import reviewlogo from "../../images/reviewLogo.svg"
import { useSearchParams } from "react-router-dom"
import { isUnderAge } from "../../utils/general";
import { ReactComponent as EnableSignIcon } from '../../images/new-appointment/active_sign.svg';
import { ReactComponent as EmptySignIcon } from '../../images/new-appointment/empty_sign.svg';
import { webBaseUrl } from "../../config"
import ForwardedMedicalThankYou from "./ForwardedMedicalThankYou"
import useWindowDimension from "../../utils/useWindowDimensions";
import BrandingHeader from "../common/branding-header/BrandingHeader";
import BrandingFooter from "../common/branding-footer/BrandingFooter";
import {VALIDATION_REGEX} from "../../utils/common-regex"
import {validPhone} from "../../utils/Regex"

const MedicalForm = ({ isHide, fromOffCanvas, setIsRes, setSelectedClient, setIsCloseFromCanvas }) => {
  const locationState = useLocation()
  const bookingDetails = {
    next_fin_status: true,
  };

  const patientDobModalRef = useRef(null);

  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [previewDataURL, setPreviewDataURL] = useState(null);
  const [tempTrimmedDataURL, setTempTrimmedDataURL] = useState(null);
  const [toggleSigned, setToggleSigned] = useState(false);
  const [isSignatureOpen, setIsSignatureOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSigned, setIsSigned] = useState(null);
  const [signedSignatureData, setSignedSignatureData] = useState(null);
  const [isNoteModal, setIsNoteModal] = useState(false);
  const [isNextOfKin, setIsNextOfKin] = useState(false);
  const [isIdentityOpen, setIsIdentityOpen] = useState(false)
  const [files, setFiles] = useState([]);

  const [countryCode, setCountryCode] = useState("GB")
  const navigate = useNavigate()
  const [value, setValue] = useState('');
  const fileInputRef = useRef(null);
  const profilePicInputRef = useRef(null);
  const checkRef = useRef(null)

  const [isPreview, setIsPreview] = useState(false);
  const [fileExist, setFileExist] = useState(false)
  const [singleFile, setSingleFile] = useState({
    clientId: null,
    documentId: "",
    documentUrl: "",
    documentName: "",
    time: ""
  })
  const [newClientRes, setNewClientRes] = useState(false)
  const [notes, setNotes] = useState('')
  const [commonLoder, setCommonLoder] = useState(null)
  const [basicInfoData, setBasicInfoData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    birthday: "",
    title: ""
  })

  const [contactDetailsData, setContactDetailsData] = useState({
    email: "",
    phoneNumber: "",
    countryCode: "",
    address: "",
    doNotSendMarketingToggle: false
  })




  // ==========================================medical form query data=======================================================
  const { saveClientMedicalFormDetailQueryData, initSaveClientMedicalFormDetailsData } = SaveClientMedicalFormDetailsAction()
  const { getclientMedicalFormDetailsQueryData, initGetClientMedicalFormData } = GetClientMedicalFormDetailsAction()
  const { saveMedicalPractitinorDetailQueryData, initSaveMedicalPractitinorDetailData } = SaveMedicalPractitinorDetailAction()
  const { getMedicalPractitinorDetailQueryData, initGetMedicalPractitinorDetailData } = GetMedicalPractitinorDetailAction()



  const [saveMedicalHistoryVal, setSaveMedicalHistoryVal] = useState(null)


  const [medicalQuestions, setMedicalQuestion] = useState([
    {
      question: null,
      id: null,
      isManual: null,
      hasSubQuestions: null,
      subQuestions: [
        {
          question: null,
          id: null,
          isManual: null,
          comment: null,
          answer: null,
          error: null,
        },
      ],
      comment: null,
      answer: null,
      error: null,
    },
  ]);
  console.log('saveMedicalHistoryVal', saveMedicalHistoryVal)

  const [practitinorModelDetail, setPractitinorModelDetail] = useState({
    gpEmail: "",
    gpName: "",
    gpAddress: "",
    gpHouseNumber: "",
    gpStreetName: "",
    gpCity: "",
    gpPostCode: "",
    gpMobile: "",
    gpPhoneNoCountry: "",
    gpCountryCode: ""
  })

  const [practitinorModelError, setpractitinorModelError] = useState({
    gpEmail: "",
    gpName: "",
    gpAddress: "",
    gpHouseNumber: "",
    gpStreetName: "",
    gpCity: "",
    gpPostCode: "",
    gpMobile: "",
    gpPhoneNoCountry: "",
    gpCountryCode: ""
  })

  const [searchParams] = useSearchParams();


  const formToken = searchParams.get('token')
  const orderIdReq = searchParams.get('prescription-order-ids')
  const paymentSessionReq = searchParams.get('ps')

  console.log("formToken", formToken)
  const prefixRef = useRef()
  const firstnameRef = useRef()
  const lastNameRef = useRef()
  const dobRef = useRef();
  const addressRef = useRef()
  const emailRef = useRef();
  const phoneNoRef = useRef();
  const medicalHistoryRef = useRef()
  const paitentSignRef = useRef();
  const practitionersignRef = useRef();
  const questionRef = useRef({});
  const subQuestionRef = useRef({})
  const checkBoxRef = useRef()
  const [shouldScroll, setshouldScroll] = useState(false);
  const [step, setStep] = useState(1)
  const [scrollCheck, setScrollCheck] = useState(false)
  const [isExpanded, setIsExpanded] = useState(null)


  console.log("practitinorModelDetail", practitinorModelDetail)
  const [isHasMedicalHistory, setIsHasMedicalHistory] = useState(null)
  //  =================================patient data==============================================
  const [patientTrimmedDataUrl, setPatientTrimmedDataUrl] = useState(null)
  const [patientPreviewDataUrl, setpatientPreviewDataUrl] = useState(null);
  const [patientTempTrimmedDataURL, setPatientTempTrimmedDataURL] = useState(null);
  const [patientToggleSigned, setPatientToggleSigned] = useState(null)
  const [isPatientSignatureOpen, setIsPatientSignatureOpen] = useState(null)
  const [isPatientSigned, setIsPatientSigned] = useState(null)
  const [patientSigntureData, setPatientSigntureData] = useState(null)
  const patientSignRef = useRef(null)

  // ============================= Practitioner  data===========================
  const [practitionerTrimmedDataUrl, setPractitionerTrimmedDataUrl] = useState(null)
  const [practitionerPreviewDataUrl, setPractitionerPreviewDataUrl] = useState(null);
  const [practitionerTempTrimmedDataURL, setPractitionerTempTrimmedDataURL] = useState(null);
  const [practitionerToggleSigned, setPractitionerToggleSigned] = useState(null)
  const [isPractitionerSignatureOpen, setIsPractitionerSignatureOpen] = useState(null)
  const [isPractitionerSigned, setIsPractitionerSigned] = useState(null)
  const [practitionerSigntureData, setPractitionerSigntureData] = useState(null)
  const practitionerSignRef = useRef(null)

  const [enterPractitionerAddress, setEnterPractitionerAddress] = useState(false);
  const [showManualPractitionerAddress, setShowManualPractitionerAddress] = useState(false);
  const [isMenualPractitionerAddress, setIsMenualPractitionerAddress] = useState(0)
  const [isConfirmedByClient, setIsConfirmedByclient] = useState("null")
  const [checkBoxVal, setCheckBoxVal] = useState(false)
  const [isPractitionerDetail, setIsPractitionerDetail] = useState("null")

  const [searchLocation, setSearchLocation] = useState("");
  const [showManualAddress, setShowManualAddress] = useState(false);
  const [longitude, setLongitude] = useState(0.0);
  const [latitude, setLatitude] = useState(0.0);
  //const [clientId,setClientId]=useState(null);
  const { clientDetailsQueryData, initGetClientDetails } = GetClientDetails()
  const [isNextofKinAdded, setIsNextOfKinAdded] = useState(false)
  const [isNoteAdded, setIsNoteAdded] = useState(false)
  const [selectedCountryLabel, setSelectedCountryLabel] = useState("");
  const clientDetails = useSelector(state => state?.clientDetailsReducer?.clientDetails)
  const clientIdentityStatus = useSelector((state) => state?.clientDetailsReducer?.clientIdentityStatus)
  const clientNoteStatus = useSelector((state) => state?.clientDetailsReducer?.clientNoteStatus)
  const clientNextOfKinStatus = useSelector((state) => state?.clientDetailsReducer?.clientNextOfKinStatus)
  const clientMedicalDetails = useSelector((state) => state.clientDetailsReducer?.clientMedicalDetailsStatus)
  const [selectedLocation, setSelectedLocation] = useState("");
  const { clientId } = useParams()
  const { screenWidth } = useDeviceDetect();
  const sigPadRef = useRef();

  //for error purpose
  const [validationErrors, setValidationErrors] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    houseNumber: "",
    streetName: "",
    city: "",
    postCode: "",
    phoneNumber: "",
    email: "",
    countryCode: "",
    address: "",
    clientSignature: "",
    practitionerSignature: "",
    isMedicalHistory: "",
    title: "",
    checkBox: "",
    futureDate: ""

  });

  //Set Client Location state
  const [location, setLocation] = useState({
    address1: "",
    address2: "",
    city: "",
    postcode: "",
    country: "",
    street: "",
    house_no: "",
    latitude: 0.0,
    longitude: 0.0,
    state: ""
  })
  const [isDeleteIconClick, setIsDeleteIconClick] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  useEffect(() => {
    // Update isMobile state when the window resizes
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      const openButton = document.querySelector(".open-button.rounded-circle");
      if (openButton) {
        openButton.style.display = "none";
      }
    }
  }, [isMobile]);

  console.log(patientSigntureData, "patientTrimmedDataUrl")

  useEffect(() => {
    if (patientTrimmedDataUrl !== undefined && patientTrimmedDataUrl !== null) {
      // Call the validation function for clientSignature whenever patientTrimmedDataUrl changes
      handleValidation("clientSignature", patientTrimmedDataUrl);
    }

    if (practitionerTrimmedDataUrl !== undefined && practitionerTrimmedDataUrl !== null) {

      // Call the validation function for clientSignature whenever patientTrimmedDataUrl changes
      handleValidation("practitionerSignature", practitionerTrimmedDataUrl);
    }

  }, [patientTrimmedDataUrl, practitionerTrimmedDataUrl]);


  const handleValidation = (fieldName, value) => {
    console.log("fieldName", fieldName)
    setValidationErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      if (fieldName === "isMedicalHistory") {
        if (value == null || value === "") {
          updatedErrors.isMedicalHistory = "Please choose medical history";
        } else {
          delete updatedErrors.isMedicalHistory;
        }
      }
      if (fieldName === "firstName") {
        if (value == null || value === "") {
          updatedErrors.firstName = "Please enter first name!";
        }else if(!VALIDATION_REGEX?.validName?.test(value)){
          updatedErrors.firstName="Please enter valid first name!"
        }
         else {
          delete updatedErrors.firstName;
        }
      }
      if (fieldName === "lastName") {
        if (value == null || value === "") {
          updatedErrors.lastName = "Please enter last name!";
        } else if(!VALIDATION_REGEX.validName?.test(value)){
           updatedErrors.lastName="Please enter valid last name!"
        }
        else {
          delete updatedErrors.lastName;
        }
      } if (fieldName === "day" && fieldName === "month" && fieldName === "year") {
        if (value == null || value === "") {
          updatedErrors.dob = "Please enter Date of birth";
        } else {
          delete updatedErrors.dob;
        }
      } if (fieldName === "address") {
        if (value == null || value === "") {
          updatedErrors.address = "Please enter address";
        } else {
          delete updatedErrors.address;
        }
      } if (fieldName === "email") {
        if (value == null || value === "") {
          updatedErrors.email = "Please enter valid email address!";
        } else {
          delete updatedErrors.email;
        }
      } if (fieldName === "phoneNumber") {
        if (value == null || value === "") {
          updatedErrors.phoneNumber = "Please enter valid phone number";
        } else if(!validPhone.test(value)){
          updatedErrors.phoneNumber = "Please enter valid phone number";
        }
        else {
          delete updatedErrors.phoneNumber;
        }
      } if (fieldName === "checkBox") {
        if (value == null || value === "") {
          updatedErrors.checkBox = "Tick the box to continue";
        } else {
          delete updatedErrors.checkBox;
        }
      } if (fieldName === "clientSignature") {
        if (patientTrimmedDataUrl !== undefined && patientTrimmedDataUrl !== null) {
          if (value == null || value === "") {
            updatedErrors.clientSignature = "Please add patient signature";
          } else {
            delete updatedErrors.clientSignature;
          }
        }

      } if (fieldName === "practitionerSignature") {
        if (practitionerTrimmedDataUrl !== undefined && practitionerTrimmedDataUrl !== null) {
          if (value == null || value === "") {
            updatedErrors.practitionerSignature = "Please add practitioner signature";
          } else {
            delete updatedErrors.practitionerSignature;
          }
        }

      } if (fieldName === "title") {
        if (value == null || value === "") {
          updatedErrors.title = "Please add signture";
        } else {
          delete updatedErrors.title;
        }
      }

      return updatedErrors;
    });
  };

  const handleFocus = (id) => {
    setIsExpanded(id)
  }

  const handleBlur = () => {
    setIsExpanded(null)
  }

  const handleMenualAddress = () => {
    setShowManualAddress(false)
    setSearchLocation(location?.country == "" ? location?.address1 + "," + location?.address2 + "," + location?.city + "," + location.postcode : location?.address1 + "," + location?.address2 + "," + location?.city + "," + location?.country + "," + location.postcode)
  }

  const handlePractitinorModel = () => {
    setShowManualPractitionerAddress(true);
    setIsMenualPractitionerAddress(1);
    setEnterPractitionerAddress(true)


    initGetMedicalPractitinorDetailData({
      clientId: parseInt(clientId),
      token: formToken ? formToken : null
    })

  }
  const handleCheckBoxval = (e) => {
    if (isConfirmedByClient) {
      setCheckBoxVal(isConfirmedByClient)
    } else {
      setCheckBoxVal(e.target.checked);
    }

    handleValidation("checkBox", checkBoxVal)
  }




  const handlePractitionersAddress = () => {

    initSaveMedicalPractitinorDetailData({
      clientId: parseInt(clientId),
      gpName: practitinorModelDetail?.gpName,
      gpEmail: practitinorModelDetail?.gpEmail,
      gpAddress: practitinorModelDetail?.gpAddress,
      // gpHouseNumber: practitinorModelDetail?.gpHouseNumber,
      // gpStreetName: practitinorModelDetail?.gpStreetName,
      // gpCity: practitinorModelDetail?.gpCity,
      // gpPostCode: practitinorModelDetail?.gpPostCode,
      gpMobile: practitinorModelDetail?.gpMobile,
      gpPhoneNoCountry: practitinorModelDetail?.gpPhoneNoCountry,
      gpCountryCode: practitinorModelDetail?.gpCountryCode,
      token: formToken ? formToken : null
    }, (data) => {
      setShowManualPractitionerAddress(false)
    }, (error) => {
      console.log(error)
    })



  }


  const handlePatientSignture = () => {
    setIsPatientSignatureOpen(false)
    setIsPatientSigned(false)
    if (patientSignRef?.current?.isEmpty() === false) {
      setPatientTrimmedDataUrl(null)
    } else {
      setPatientTrimmedDataUrl(patientTempTrimmedDataURL)
    }
  }

  const handlePractitionerSignture = () => {
    setIsPractitionerSignatureOpen(false)
    setIsPractitionerSigned(false)
    if (practitionerSignRef?.current?.isEmpty() === false) {
      setPractitionerTrimmedDataUrl(null)
    } else {
      setPractitionerTrimmedDataUrl(practitionerTempTrimmedDataURL)
    }
  }

  const handlePractitioner = (e) => {
    const { name, value } = e.target;
    setPractitinorModelDetail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  //State for nextofKin
  const [nextOfKinData, setNextOfKinData] = useState({
    firstName: "",
    lastName: "",
    relation: "",
    phoneCountry: "",
    phone: "",
  })
  //Date of Birth
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  const [clientOriginalDob, setClientOriginalDob] = useState(null);

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [dobError, setDobError] = useState(false);
  const [dobValue, setDobValue] = useState('');
  const [singleClick, setSingleClick] = useState(null)
  const imgRef = useRef(null);
  const [isClose, setIsClose] = useState(false)
  const [isMenualAddress, setIsMenualAddress] = useState(0)
  const [diffAdd, setDiffAdd] = useState("")
  const [enterAddress, setEnterAddress] = useState(false);
  const [isDeleteIdentity, setIsDeleteIdentity] = useState(false);
  const [profilePreviewUrl, setProfilePreviewUrl] = useState();
  const [isProfilePicPresent, setIsProfilePicPresent] = useState(false);
  const [isProfilePreview, setIsProfilePreview] = useState(false);
  const [isDeleteProfileConfirm, setIsDeleteProfileConfirm] = useState(false);


  const clientMedicalFormDetail = getclientMedicalFormDetailsQueryData?.data?.getClientMedicalFormDetails?.data;


  const [formInvalid, setFormInvalid] = useState(false);

  //Handle Phonenumber selection
  const handleCountryChange = (country) => {
    setCountryCode(country);
    setPractitinorModelDetail((prevState) => ({
      ...prevState,
      gpCountryCode: country,
    }));
    console.log("selected country", country)
    // Get the label based on the selected country
    const selectedLabel = getCountries().includes(country)
      ? `${getCountryCallingCode(country)}`
      : "";

    setSelectedCountryLabel(selectedLabel);
  };

  console.log("first akash", clientIdentityStatus, singleFile)
  const dispatch = useDispatch()

  useEffect(() => {

    var date = moment(year + '-' + month + '-' + day).format("YYYY-MM-DD")

    if (day == "" && month == "" && year == "") {

      setDobError(false);
    }
    else if (day && month && year && day?.length == 2 && month.length == 2 && year?.length == 4 && date < moment().format("YYYY-MM-DD")) {

      setDobError(false);
      setDobValue(date);
    } else if (day && month && year) {
      const enteredDate = new Date(year, month - 1, day); // Month is 0-based in JS Date
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to compare only date
      setDobError(false);
      setDobValue(date);
      if (enteredDate > today) {
        validationErrors.dob = "Date of birth cannot be in the future";
      } else {
        setDobValue('')
        setDobError(true);
        validationErrors.dob = ""
      }
    }

    console.log('datedatedate', date < moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), "YYYY-MM-DD", date, "year", year, "month", month, "day", day)
    console.log("ddddddd", day, month, year, dobError, dobValue)
  }, [day, month, year])




  //Create Client Mutation
  const { initiateCreateClient, createClientMutationData } = CreateClient();
  //Add Identity Document Mutation
  const { createIdentityMutationData, initiateCreateIdentity } = CreateIdentityDocument();
  //Delete Identity Document Mutation
  const { initiateDeleteIdentity, deleteIdentityMutationData } = DeleteIdentityDocument()
  //Get Next Of KinData
  const { initGetNextOfKinDetails } = GetNextOfKinDetails()
  //Get Identity Data

  const { initiateDeleteClientProfile, deleteClientProfileMutationData } = DeleteProfileImage()

  const { identityQueryData, initGetIdentity } = GetIdentityDocumentDataQuery()


  const countZeroReg = /^0+$/

  //  ========================== call get API ==================================
  useEffect(() => {
    initGetClientMedicalFormData({
      clientId: parseInt(clientId),
      token: formToken ? formToken : null
    })
  }, [])






  const handleMedicalHistoryData = (e) => {
    setSaveMedicalHistoryVal(e.target.value)
    handleValidation("isMedicalHistory", e.target.value)
    setScrollCheck(true)
    if (clientMedicalFormDetail?.medical_qas) {
      const formattedMedicalData = clientMedicalFormDetail?.medical_qas?.map((question) => ({

        question: question?.question,
        id: question?.id,
        isManual: question?.isManual,
        hasSubQuestions: question?.hasSubQuestions,
        subQuestions: question?.subQuestions?.map((subQue) => ({
          question: subQue?.question,
          id: subQue?.id,
          isManual: subQue?.isManual,
          comment: subQue?.comment,
          answer:
            e.target.value === "no"
              ?
              (subQue?.isManual == null
                ? subQue?.answer
                : (subQue?.isManual === false
                  ? 0
                  : null)
              )
              :
              e.target.value === "yes" ? null : ""
        })),
        comment: question?.comment,
        answer:
          e.target.value === "no"
            ?
            (question?.isManual == null
              ? question?.answer
              : (question?.isManual === false
                ? 0
                : null)
            )
            :
            e.target.value === "yes" ? null : ""
      }))
      console.log('formattedMedicalData', formattedMedicalData)
      setMedicalQuestion(formattedMedicalData)
    }
    if (e.target.value === "no" && isHasMedicalHistory !== null) {

      const updatedQuestions = medicalQuestions.map((question) => ({
        ...question,
        answer: 0,
        subQuestions: question?.subQuestions?.map((subQuestion) => ({
          ...subQuestion,
          answer: 0,
        })),
      }));
      setMedicalQuestion(updatedQuestions);
    }
  }

  useEffect(() => {
    if (saveMedicalHistoryVal === "no" && scrollCheck) {
      if (checkRef?.current) {
        checkRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
      setScrollCheck(false)
    }
  }, [checkRef?.current, saveMedicalHistoryVal, scrollCheck])


  const handleMedicalRadio = (i, updatedField) => {
    setMedicalQuestion((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];

      // Update the specific main question
      updatedQuestions[i] = {
        ...updatedQuestions[i],
        ...updatedField,
      };

      // Validate the main question
      const isQuestionAnswered =
        updatedQuestions[i].answer !== null && updatedQuestions[i].answer !== "";
      updatedQuestions[i].error = isQuestionAnswered
        ? null
        : "This question is required.";

      return updatedQuestions;
    });
  };


  // const handleMedicalSubQuestion = (questionIndex, subIndex, updatedField) => {
  //   setMedicalQuestion((prevQuestions) => {
  //     const updatedQuestions = [...prevQuestions];
  //     const updatedSubQuestions = [...updatedQuestions[questionIndex].subQuestions];
  //     updatedSubQuestions[subIndex] = {
  //       ...updatedSubQuestions[subIndex],
  //       ...updatedField,
  //     };
  //     updatedQuestions[questionIndex] = {
  //       ...updatedQuestions[questionIndex],
  //       subQuestions: updatedSubQuestions,

  //     };
  //     return updatedQuestions;
  //   });

  // }
  const handleMedicalSubQuestion = (questionIndex, subIndex, updatedField) => {
    setMedicalQuestion((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      const updatedSubQuestions = [...updatedQuestions[questionIndex].subQuestions];

      // Update the specific subquestion
      updatedSubQuestions[subIndex] = {
        ...updatedSubQuestions[subIndex],
        ...updatedField,
      };

      // Validate the updated subquestion
      const isSubQuestionAnswered =
        updatedSubQuestions[subIndex].answer !== null &&
        updatedSubQuestions[subIndex].answer !== "";
      updatedSubQuestions[subIndex].error = isSubQuestionAnswered
        ? null
        : "This subquestion is required.";

      // Update the main question with the updated subquestions
      updatedQuestions[questionIndex] = {
        ...updatedQuestions[questionIndex],
        subQuestions: updatedSubQuestions,
      };

      return updatedQuestions;
    });
  };




  function isValidEmail(email) {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
     return emailPattern.test(email);
  }

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0)?.toUpperCase() + str.slice(1)?.toLowerCase();
  };

  function removeBase64Prefix(base64Data) {
    const prefix = 'data:image/png;base64,';

    // Check if the base64Data starts with the prefix
    if (base64Data?.startsWith(prefix)) {
      // Remove the prefix
      return base64Data?.slice(prefix.length);
    } else {
      // If the prefix is not found, return the original string
      return base64Data;
    }
  }


  //When Come from any Screen to Edit Client
  console.log("6554653", saveMedicalHistoryVal, medicalQuestions)
  useEffect(() => {
    if (clientId) {
      if (getclientMedicalFormDetailsQueryData?.data) {

        console.log('clientMedicalFormDetail', clientMedicalFormDetail)
        const fullName = clientMedicalFormDetail?.name || "";
        const [firstName, ...rest] = fullName.split(" ");
        const lastName = rest.join(" ");
        const formattedTitle = capitalizeFirstLetter(clientMedicalFormDetail.title);
        setBasicInfoData({
          firstName: firstName,
          lastName: lastName,
          title: formattedTitle
        })


        console.log("clientMedicalFormDetail", clientMedicalFormDetail, basicInfoData)
        setClientOriginalDob(clientMedicalFormDetail?.dob)
        if (clientMedicalFormDetail?.dob !== null) {
          const dob = clientMedicalFormDetail?.dob?.split("-")
          setDay(dob[2])
          setMonth(dob[1])
          setYear(dob[0])
        }

        setContactDetailsData({
          email: clientMedicalFormDetail?.email,
          phoneNumber: clientMedicalFormDetail?.mobile
        })

        setCountryCode(clientMedicalFormDetail?.country_code?.toUpperCase())

        setLocation({
          ...location,
          postcode: clientMedicalFormDetail?.postcode,
          latitude: clientMedicalFormDetail?.latitude,
          longitude: clientMedicalFormDetail?.longitude,
          address1: clientMedicalFormDetail?.house_no,
          address2: clientMedicalFormDetail?.street_name,
          city: clientMedicalFormDetail?.city
        })
        console.log("clientMedicalFormDetail?.address", clientMedicalFormDetail?.address)
        setSearchLocation(clientMedicalFormDetail?.address)


        if (clientMedicalFormDetail?.medical_qas) {
          const formattedMedicalData = clientMedicalFormDetail?.medical_qas?.map((question) => ({

            question: question?.question,
            id: question?.id,
            isManual: question?.isManual,
            hasSubQuestions: question?.hasSubQuestions,
            subQuestions: question?.subQuestions?.map((subQue) => ({
              question: subQue?.question,
              id: subQue?.id,
              isManual: subQue?.isManual,
              comment: subQue?.comment,
              answer:
                clientMedicalFormDetail?.hasMedicalHistory === false
                  ?
                  (subQue?.isManual == null
                    ? subQue?.answer
                    : (subQue?.isManual === false
                      ? 0
                      : null)
                  )
                  :
                  clientMedicalFormDetail?.hasMedicalHistory === true ? subQue?.answer : ""
            })),
            comment: question?.comment,
            answer:
              clientMedicalFormDetail?.hasMedicalHistory === false
                ?
                (question?.isManual == null
                  ? question?.answer
                  : (question?.isManual === false
                    ? 0
                    : null)
                )
                :
                clientMedicalFormDetail?.hasMedicalHistory === true ? question?.answer : ""
          }))
          console.log('formattedMedicalData', formattedMedicalData)
          setMedicalQuestion(formattedMedicalData)
        }
        if (clientMedicalFormDetail?.hasMedicalHistory === true) {
          setSaveMedicalHistoryVal("yes")
        } else if (clientMedicalFormDetail?.hasMedicalHistory === false) {
          setSaveMedicalHistoryVal("no")
        } else if (clientMedicalFormDetail?.hasMedicalHistory === null) {
          setSaveMedicalHistoryVal(null)
        }

        setIsHasMedicalHistory(clientMedicalFormDetail?.hasMedicalHistory)
        setIsConfirmedByclient(clientMedicalFormDetail?.isConfirmedByClient)
        setIsPractitionerDetail(clientMedicalFormDetail?.isPractitionerDetail)
        setCheckBoxVal(clientMedicalFormDetail?.isConfirmedByClient)
        if (clientMedicalFormDetail?.medical_signature) {
          setPatientSigntureData(clientMedicalFormDetail?.medical_signature)
          setIsPatientSigned(false)
          setPatientToggleSigned(true)
        } else {
          setPatientToggleSigned(false)
          setIsPatientSigned(false)
        }

        if (clientMedicalFormDetail?.practitioner_signature) {
          setPractitionerSigntureData(clientMedicalFormDetail?.practitioner_signature)
          setIsPractitionerSigned(false)
          setPractitionerToggleSigned(true)
        } else {
          setPractitionerToggleSigned(false)
          setIsPractitionerSigned(false)
        }
      }

    }
  }, [getclientMedicalFormDetailsQueryData?.data])

  console.log("medicalQuestions2222", medicalQuestions, saveMedicalHistoryVal)

  useEffect(() => {
    if (clientId) {
      if (getMedicalPractitinorDetailQueryData.data) {
        const practitinorData = getMedicalPractitinorDetailQueryData.data?.getMedicalFormPractitionerDetails?.data;
        setPractitinorModelDetail({
          gpName: practitinorData?.prc_name,
          gpEmail: practitinorData?.prc_email,
          gpAddress: practitinorData?.prc_address,
          // gpHouseNumber: practitinorData?.prc_house_no,
          // gpStreetName: practitinorData?.prc_street_name,
          // gpCity: practitinorData?.prc_city,
          // gpPostCode: practitinorData?.prc_postcode,
          gpMobile: practitinorData?.prc_mobile,
          gpPhoneNoCountry: practitinorData?.prc_phone_country,
          gpCountryCode: practitinorData?.prc_country_code
        })
      }
    }
  }, [clientId, getMedicalPractitinorDetailQueryData.data])

  console.log(clientMedicalFormDetail?.medical_qas, "clientMedicalFormDetail?.medical_qas")

  const validateQuestions = () => {
    const updatedQuestions = medicalQuestions.map((question) => {
      // Check if the main question has an answer
      const isQuestionAnswered = question.answer !== null && question.answer !== "";
      const questionError = !question.hasSubQuestions ? isQuestionAnswered ? null : "This question is required." : "";

      // Check subquestions
      const updatedSubQuestions = question.subQuestions.map((subQuestion) => {
        const isSubQuestionAnswered =
          subQuestion.answer !== null && subQuestion.answer !== "";
        return {
          ...subQuestion,
          error: isSubQuestionAnswered ? null : "This subquestion is required.",
        };
      });

      // Return the updated question object with errors
      return {
        ...question,
        error: questionError,
        subQuestions: updatedSubQuestions,
      };
    });

    setMedicalQuestion(updatedQuestions);

    // Check if there are any errors
    const hasErrors = updatedQuestions.some(
      (q) => q.error || q.subQuestions.some((sq) => sq.error)
    );
    return !hasErrors; // Return true if there are no errors
  };


  useEffect(() => {
    if (shouldScroll) {
      if (prefixRef.current) {
        prefixRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })

      } else if (firstnameRef.current) {
        firstnameRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })

      } else if (lastNameRef.current) {
        lastNameRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (dobRef.current) {
        dobRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (addressRef.current) {
        addressRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (emailRef.current) {
        emailRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (phoneNoRef.current) {
        phoneNoRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (medicalHistoryRef.current) {
        medicalHistoryRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      }
      else if (Object.values(subQuestionRef.current).filter((v) => v != null).length > 0) {

        const handleScrollToError = () => {
          let scrolled = false;

          medicalQuestions.forEach((question, questionIndex) => {
            question.subQuestions?.forEach((subque, subIndex) => {
              if (subque.error && !scrolled) {
                const refKey = `${questionIndex}-${subIndex}`;
                const errorRef = subQuestionRef.current[refKey];
                if (errorRef) {
                  errorRef.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                  scrolled = true;
                }
              }
            });
          });
        };
        handleScrollToError()

      } else if (Object.values(questionRef.current).filter((v) => v != null).length > 0) {

        const scrollToQuestionError = () => {

          Object.values(questionRef.current).some((ref) => {
            if (ref) {
              ref.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              return true;
            }
            return false;
          });
        };
        scrollToQuestionError()
      }
      else if (paitentSignRef.current) {
        paitentSignRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (practitionersignRef.current) {
        practitionersignRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      } else if (checkBoxRef.current) {
        checkBoxRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      }
      setshouldScroll(false)
    }
  }, [validationErrors])


  const handleSubmitMedicalForm = () => {

    const validationErrors = {};
    if (!basicInfoData?.firstName) {
      validationErrors.firstName = "Please enter first name!"
     }else if(!VALIDATION_REGEX.validName?.test(basicInfoData?.firstName)){
      validationErrors.firstName="Please enter valid first name!"
     }


    if (!basicInfoData?.lastName) {
      validationErrors.lastName = "Please enter last name!"
    }else if(!VALIDATION_REGEX.validName?.test(basicInfoData?.lastName)){
      validationErrors.lastName="Please enter valid last name!"
    }


    if (!basicInfoData?.title) {
      validationErrors.title = "Please select title!"
    }
    if (!contactDetailsData.email || !isValidEmail(contactDetailsData.email)) {
      validationErrors.email = "Please enter valid email address!"
    }
    if (!contactDetailsData.phoneNumber) {
      validationErrors.phoneNumber = "Please enter valid phone number!"
    }else if(!validPhone.test(contactDetailsData.phoneNumber)){
      validationErrors.phoneNumber="Please enter valid phone number"
    }

    if (!day && !month && !year && !dobError) {
      validationErrors.dob = "Please enter Date of birth!"
    }
    
    if (day && month && year) {
      var date = moment(year + '-' + month + '-' + day).format("YYYY-MM-DD")
      const enteredDate = new Date(year, month - 1, day); // Month is 0-based in JS Date
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to compare only date
      setDobError(false);
      setDobValue(date);
      if (enteredDate > today) {
        validationErrors.dob = "Date of birth cannot be in the future";
      } else {
      setDobValue(date);
        setDobError(true);
        validationErrors.dob = ""
      }

    }


    if (!saveMedicalHistoryVal) {
      validationErrors.isMedicalHistory = "Please choose medical history";
    }

    if (!patientSigntureData) {
      validationErrors.clientSignature = "Please add patient signature"
    }
    // if (formToken) {
    //   if (!practitionerSigntureData) {
    //     validationErrors.practitionerSignature = ""
    //   }
    // } else {
    //   if (!practitionerSigntureData) {
    //     validationErrors.practitionerSignature = "Please add practitioner signature"
    //   }
    // }


    if (!searchLocation) {
      validationErrors.address = "Please enter address"
    }
    if (!checkBoxVal && !isConfirmedByClient) {
      validationErrors.checkBox = "Tick the box to continue"
    }


    const questionValidation = validateQuestions()
    setValidationErrors(validationErrors)
    setshouldScroll(true)



    medicalQuestions?.forEach(item => {
      delete item.isManual
      item?.subQuestions?.forEach(val => {
        delete val?.isManual
      })
      return medicalQuestions
    })
    medicalQuestions?.forEach(item => {
      delete item.error
      item?.subQuestions?.forEach(val => {
        delete val?.error
      })
      return medicalQuestions
    })

    if (Object.values(validationErrors).some((error) => error) || !questionValidation) {
      return;
    }
    else {
      initSaveClientMedicalFormDetailsData({
        title: basicInfoData?.title?.toLocaleUpperCase(),
        clientId: parseInt(clientId),
        firstName: basicInfoData?.firstName,
        lastName: basicInfoData?.lastName,
        dob: dobValue,
        latitude: location?.latitude?.toString(),
        longitude: location?.longitude?.toString(),
        address: searchLocation,
        houseNumber: location?.house_no || location.address1,
        streetName: location?.street || location?.address2,
        city: location.city,
        postCode: location.postcode?.toString(),
        email: contactDetailsData.email,
        mobile: contactDetailsData.phoneNumber,
        phoneNoCountry: getCountryCallingCode(countryCode),
        countryCode: contactDetailsData.countryCode?.toLowerCase(),
        medicalHomeTelephone: null,
        medicalOfficeTelephone: null,
        qas: medicalQuestions,
        clientSignature: patientSigntureData === getclientMedicalFormDetailsQueryData?.data?.getClientMedicalFormDetails?.data?.medical_signature ? "" : removeBase64Prefix(patientSigntureData),
        // practitionerSignature: practitionerSigntureData === getclientMedicalFormDetailsQueryData?.data?.getClientMedicalFormDetails?.data?.practitioner_signature ? "" : removeBase64Prefix(practitionerSigntureData),
        isMedicalHistory: saveMedicalHistoryVal === "yes" ? 1 : saveMedicalHistoryVal === "no" ? 2 : null,
        token: formToken ? formToken : null,
        clientIds: []
      },
        (data) => {
          console.log("", data)
          toast.success("Medical form saved successfully")
          if (paymentSessionReq && orderIdReq) {
            window.location.href = `${webBaseUrl}/ryft/payment-response?order-ids=&prescription-order-ids=${orderIdReq}&type=combined-order&ps=${paymentSessionReq}`
          } else if (formToken) {
            setStep(2);
          }
          else {
            if (locationState?.state?.fromAppointment)
              navigate(-1)
            if (clientId) {
              navigate(-1)
            }
            else {
              navigate(getSearchClientRoute())
            }
          }
        }, (error) => { toast.error(error?.data?.saveClientMedicalFormDetails?.message) })
    }

  }

  console.log("dobval", validationErrors,)

  const handlePaitentSigntureModelClose = () => {
    setIsPatientSignatureOpen(false)
    setIsPatientSigned(false)
    setPatientToggleSigned(true)
  }

  const handlePractitionerSignModelClose = () => {
    setIsPractitionerSignatureOpen(false)
    setIsPractitionerSigned(false)
    setPractitionerToggleSigned(true)
  }


  const paitentClear = () => {
    patientSignRef?.current?.clear();
    setPatientTrimmedDataUrl(null);
    setpatientPreviewDataUrl('')
    setPatientSigntureData(null)

    setIsPatientSigned(true)
    setPatientToggleSigned(true)
    setIsPatientSignatureOpen(true)
    setPatientTempTrimmedDataURL(null)
  }

  const PractitionerClear = () => {
    practitionerSignRef?.current?.clear();
    setPractitionerTrimmedDataUrl(null)
    setPractitionerPreviewDataUrl("")
    setPractitionerSigntureData(null)

    setIsPractitionerSigned(true)
    setPractitionerToggleSigned(true)
    setIsPractitionerSignatureOpen(true)
    setPractitionerTempTrimmedDataURL(null)
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInvalid(false);
    setBasicInfoData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setContactDetailsData((prev) => ({
      ...prev,
      [name]: value,
    }));
    handleValidation(name, value);
  }

  const handleAddCloseClient = () => {
    setIsNoteModal(false)
  };



  //for countrySelection
  const CountrySelect = ({ value, onChange, selectedLabel, labels, ...rest }) => (
    <div className="country-selection-container">
      <select
        {...rest}
        value={value}
        onChange={event => onChange(event.target.value || undefined)}>
        <option value="">
          {labels['ZZ']}

        </option>
        {getCountries().map((country, i) => (
          country !== 'International' &&
          <option key={country} value={country}>
            {`+${getCountryCallingCode(country)}`}
          </option>


        ))}
      </select>
      <span className="selected-label">{selectedLabel}</span>
    </div>
  )

  CountrySelect.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    labels: PropTypes.objectOf(PropTypes.string).isRequired,
    selectedLabel: PropTypes.string,
  }

  const [selectedGender, setSelectedGender] = useState();



  const handleBack = () => {

    if (paymentSessionReq && orderIdReq) {
      window.location.href = `${webBaseUrl}/ryft/payment-response?order-ids=&prescription-order-ids=${orderIdReq}&type=combined-order&ps=${paymentSessionReq}`
    }
    else {
      if (locationState?.state?.fromAppointment)
        navigate(-1)
      if (clientId) {
        // navigate(getClientProfileRoute(clientId))
        navigate(-1)
      }
      else {
        navigate(getSearchClientRoute())
      }
    }


  }



  const hidePatientSignature = () => {
    setpatientPreviewDataUrl(patientSigntureData)
    setIsPatientSigned(false)
    setPatientToggleSigned(true)
    setIsPatientSignatureOpen(true)
    handleValidation("clientSignature", patientSigntureData)
  }

  const hidePractitionerSignture = () => {
    setPractitionerPreviewDataUrl(practitionerSigntureData)
    setIsPractitionerSigned(false)
    setPractitionerToggleSigned(true)
    setIsPractitionerSignatureOpen(true)
    handleValidation("practitionerSignature", practitionerSigntureData)
  }
  //Address
  const handleLocationChange = (e) => {
    setLocation({
      ...location,
      [e.target.name]: e.target.value
    })
  }

  //Goto Medical Details Page
  const redirectMedicalDetails = () => {
    window.open(`${process.env.REACT_APP_WEB_BASE_URL}/client-directory/edit/${clientId}?active-tab=medical_form`, "_blank")
  }


  const titleArray = ["Mr", "Mrs", "Miss", "Ms", "Mx"]

  const customStyle = {

    menuPortal: base => ({
      ...base,
      zIndex: 9999 // Adjust the z-index value according to your requirement
    }),
    control: (styles, state) => ({
      ...styles, backgroundColor: '#FFFFFF',
      // border: state.isFocused ? 0 : 0,
      '&:hover': {
        boxShadow: 'none'
      },
      boxShadow: 'none',
      outline: "none",
      appearance: "none",
      padding: "10px 10px",
      borderRadius: "10px",
      border: "1px solid #878787",
      height: "55px"
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {

      return {
        ...styles,
        // border: isFocused ? 'none' : 'none'
      };
    },
  };

  const handleTitleChange = (value) => {
    setBasicInfoData((prevData) => ({
      ...prevData,
      title: value
    }));
    handleValidation("title", value)
  }

  const dimensions = useWindowDimension();
  const [headerNavbar, setHeaderNavbar] = useState(0);
  const [searchHeaderWrapper, setSearchHeaderWrapper] = useState(0);
  const [footerBtnHeight, setFooterBtnHeight] = useState(0);
  const Padding20 = 20;
  console.log('headerNavbar, searchHeaderWrapper, footerBtnHeight ', headerNavbar, searchHeaderWrapper, footerBtnHeight);

  useEffect(() => {
    setHeaderNavbar(
      document.getElementsByClassName('nav-header-without-padding-container')[0]?.offsetHeight || Padding20
    );

    setSearchHeaderWrapper(
      document.getElementsByClassName('medicalFormHeaderWithBranding')[0]?.offsetHeight || 0
    );

    setFooterBtnHeight(
      document.getElementsByClassName('FooterBtn')[0]?.offsetHeight || 0
    );



    window.addEventListener('resize', handleResize);
  }, []);
  const handleResize = () => {
    setHeaderNavbar(
      document.getElementsByClassName('nav-header-without-padding-container')[0]?.offsetHeight || Padding20
    );

    setSearchHeaderWrapper(
      document.getElementsByClassName('medicalFormHeaderWithBranding')[0]?.offsetHeight || 0
    );

    setFooterBtnHeight(
      document.getElementsByClassName('FooterBtn')[0]?.offsetHeight || 0
    );

  };

  console.log("stepsws", step)
  return (
    <>
      {
        step == 1 && (
          <div className="Main-addclient-container">
            <div class="CustomeNewClientMain custom-add-client-container">
              <div className="sticky-header">
                {fromOffCanvas && <div className="close-btn">
                  <CloseIcon className='close-icon-animation' ref={imgRef} onClick={() => { setIsClose(false); isHide(false); }} />
                </div>}
              </div>

              {
                !formToken && (
                  screenWidth < 576 ?
                    <NavHeader btnLabel={"Next"} disabled={formInvalid || createClientMutationData?.loading} isLoading={createClientMutationData?.loading} applyPadding={false} handleOnBack={() => handleBack()}
                      // onClickCallback={() => handleClientAdd()} 
                      isBackOnly={true}
                    />
                    :
                    <NavHeader applyPadding={false} isBackOnly={true} handleOnBack={() => handleBack()} />
                )

              }
              <div className="new-add-client-container MainMedicalFormField">
                <div className={`maxWidth540 ${headerNavbar == Padding20 ? 'paddintTop20' : 'paddintTop80'} mt-15-575`}>
                  <div className={`row justify-content-between align-items-start`}>
                    <div className={`${"col-lg-12 col-md-12"}`}>
                      <div className="medicalFormHeaderWithBranding">
                        {formToken && (
                          <div className="py-3">
                            <BrandingHeader 
                              companyName={clientMedicalFormDetail?.businessName}
                              companyProfileImage={clientMedicalFormDetail?.companyProfile}
                            />
                          </div>
                        )}
                        <CustomeHeading
                          Title="Medical form"
                          Desc={formToken ? 
                          "Please complete the medical form below" 
                          : 
                          "Please verify the details with your patient before saving any changes."
                          }
                      />
                      </div>
                      <div className="left-content custom-padding-120" style={{ height: dimensions?.height - headerNavbar - searchHeaderWrapper - footerBtnHeight + 'px', overflowY: 'auto', overflowX: 'hidden' }}>
                        {/* <h1>Medical form</h1>
                    <div className="title-with-content">
                        <h1>Medical details attached to the client</h1>
                    </div> */}
                        <div className="title-with-content">
                          {/* {basic info start} */}
                          <div className={`d-flex flex-column ${validationErrors ? "gap-2" : "gap-4"} error-section`}>

                            <div className="client-title">
                              <CustomDropdown
                                labelName={"Title"}
                                defaultValue={basicInfoData?.title}
                                dropdownId={"title"}
                                placeholdername={"Title"}
                                optionsArr={titleArray}
                                style={customStyle}
                                handleSelectedValue={handleTitleChange}
                              />
                              {validationErrors.title && <span ref={prefixRef} className="error">{validationErrors.title}</span>}
                            </div>

                            <div>
                              <TextInput
                                id="firstName"
                                label="First name"
                                placeholder="First name"
                                name="firstName"
                                value={basicInfoData?.firstName}
                                onChange={(e) => handleChange(e)}
                              />
                              {validationErrors.firstName && <span ref={firstnameRef} className="error">{validationErrors.firstName}</span>}
                            </div>

                            <div>
                              <TextInput
                                label="Last name"
                                placeholder="Last name"
                                name="lastName"
                                value={basicInfoData?.lastName}
                                onChange={(e) => handleChange(e)}
                              />
                              {validationErrors.lastName && <span ref={lastNameRef} className="error">{validationErrors.lastName}</span>}
                            </div>

                          </div>

                          <div className="d-flex justify-content-between align-items-center">
                            <div className="row w-100 m-auto">
                              <div className="BirthdayWrapper p-0">
                                <label className="form-label">Date of birth</label>

                                <div className="BirthdayRow">

                                  <div className="col-md-4">
                                    <TextInput
                                      label="&nbsp;"
                                      placeholder="DD"
                                      maxLength={"2"}
                                      id={"day"}
                                      name="day"
                                      type="text"
                                      min="1"
                                      ref={dayRef}
                                      max="31"
                                      value={day}
                                      onChange={(e) => {
                                        if (e.target.value.length >= 2) {
                                          document.getElementById("month").focus()
                                        }
                                        const inputValue = e.target.value;
                                        handleValidation("day", inputValue)
                                        if (inputValue === "") {
                                          setDobError(true)
                                        }
                                        const regex = /^[0-9]{0,2}$/;
                                        if (regex.test(inputValue)) {
                                          setDay(inputValue);
                                        }
                                      }}
                                    />

                                  </div>
                                  <div className="col-md-4 ">
                                    <TextInput
                                      label='&nbsp;'
                                      id={"month"}
                                      placeholder="MM"
                                      name="month"
                                      min="1"
                                      max="12"
                                      maxLength="2"
                                      type="text"
                                      ref={monthRef}
                                      value={month}
                                      onKeyDown={(e) => {
                                        if (!e.target.value && e.key === "Backspace") {
                                          document.getElementById("day").focus()
                                        }
                                      }}
                                      onChange={(e) => {
                                        if (e.target.value >= 2) { document.getElementById("year").focus() };
                                        const inpValue = e?.target?.value;
                                        handleValidation("month", inpValue)
                                        if (inpValue == "") {
                                          setDobError(true);
                                        }
                                        const regex = /^[0-9]{0,2}$/;
                                        if (regex.test(inpValue)) {
                                          setMonth(inpValue);
                                        }
                                      }}
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <TextInput
                                      label="&nbsp;"
                                      placeholder="YYYY"
                                      maxLength={4}
                                      ref={yearRef}
                                      type="text"
                                      name="year"
                                      id={"year"}
                                      min="1900"
                                      max="2024"
                                      value={year}
                                      onKeyDown={(e) => {
                                        if (!e.target.value && e.key === "Backspace") {
                                          document.getElementById("month").focus()
                                        }
                                      }}
                                      onChange={(e) => {
                                        console.log("key pressed", e.target.value);
                                        const inputValue = e?.target?.value;
                                        handleValidation("year", inputValue)
                                        const regex = /^[0-9]{0,4}$/;
                                        if (inputValue == "") {
                                          setDobError(true);
                                        }
                                        if (regex.test(inputValue) || inputValue == "") {
                                          setYear(inputValue);
                                        }
                                      }}
                                    />
                                  </div> </div>
                                {(validationErrors.dob && !dobError) && <span ref={dobRef} className="error">{validationErrors.dob}</span>}
                              </div>

                            </div>
                          </div>

                          {/* {basic info end} */}

                          {/* <div className="title-with-content">             */}
                          <div className="location-container">

                            <label className="form-label"> Address </label>
                            <div className="locationInputWrapper">
                              <div className="location-icon">
                                <img src={locationIcon} alt="location-icon" />
                              </div>
                              <Autocomplete
                                icon={false}
                                apiKey={googleApiKey}
                                defaultValue={searchLocation}
                                onPlaceSelected={(place) => {
                                  setSearchLocation(place.formatted_address);
                                  const location = place.address_components.reduce(
                                    (seed, { long_name, types }) => (
                                      types.forEach((t) => (seed[t] = long_name)), seed
                                    ),
                                    {}
                                  );
                                  setLocation({
                                    ...location,
                                    street: location.route,
                                    address1: place.address_components[0].long_name,
                                    address2: place.address_components[1].long_name,
                                    postcode:
                                      location.postal_code === undefined
                                        ? ""
                                        : location.postal_code,
                                    city:
                                      location.locality === undefined
                                        ? location.postal_town === undefined
                                          ? ""
                                          : location.postal_town
                                        : location.locality,
                                    country: location.country,
                                    state:
                                      location.administrative_area_level_1 === undefined
                                        ? location.administrative_area_level_2
                                        : location.administrative_area_level_1,
                                    latitude: place.geometry.location.lat(),
                                    longitude: place.geometry.location.lng(),
                                  });
                                  console.log(place, "i am getplace data");
                                }}
                                placeholder="Search for postcode or address..."
                                className={"form-control"}
                                value={searchLocation}
                                onChange={(e) => {
                                  setSearchLocation(e.target.value)
                                  handleValidation("address", e.target.value)
                                }}
                                options={{ types: ["establishment"], componentRestrictions: { country: "uk" }, }}
                              />
                            </div>
                            {
                              validationErrors.address && <span ref={addressRef} className="error">{validationErrors.address}</span>
                            }
                            <div className="w-100">
                              <h1 onClick={() => { setShowManualAddress(true); setIsMenualAddress(1); setEnterAddress(true) }}>Add manually</h1>
                            </div>
                          </div>

                          <div className={`d-flex flex-column ${validationErrors ? "gap-2" : "gap-4"} error-section`}>
                            <div>
                              <TextInput
                                label="Email address"
                                placeholder="name@gmail.com"
                                value={contactDetailsData?.email}
                                onChange={(e) => handleChange(e)}
                                name="email"
                              />
                              {validationErrors.email && <span ref={emailRef} className="error">{validationErrors.email}</span>}
                            </div>

                          </div>

                          <div className="phone-section">
                            <label className="form-label"> Your phone number </label>
                            <div className="row">
                              <div className="col-5 col-sm-4 pe-0">
                                <CountrySelect labels={{ 'ZZ': 'Select Country' }} value={countryCode} onChange={(e) => handleCountryChange(e)} />
                              </div>
                              <div className="col-7 col-sm-8">
                                <TextInput
                                  name="phoneNumber"
                                  value={contactDetailsData?.phoneNumber}
                                  onChange={(e) => handleChange(e)}
                                  placeholder="Enter phone number"
                                />
                              </div>
                            </div>
                            {validationErrors.phoneNumber && <span ref={phoneNoRef} className="error">{validationErrors.phoneNumber}</span>}
                          </div>

                          <div className="title-with-content">
                            <div className="d-flex  justify-content-between treatment-main-action align-items-center gap-3"
                              onClick={() =>
                                handlePractitinorModel()
                              }
                            >
                              <div className="treatment-actions-content d-flex gap-2 treatment-main-action align-items-center">

                                <div className=" position-relative">
                                  <div className="IconWrapper">
                                    <GpLogo />
                                    <div className="TagBatchNumber">
                                      {
                                        isPractitionerDetail ? <TimeIcon2 /> : <TimeIcon1 />
                                      }
                                    </div>

                                  </div>
                                </div>



                                <div className="tile-text-section text-center align-items-center">
                                  <p>General practitioners (GP / Doctors)</p>
                                </div>
                              </div>
                              <RightArrow />
                            </div>
                          </div>

                          <div>
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="justify-content-between m-0 w-100 ">
                                <div className="title-with-content">
                                  <label className="form-label"> Do you have any known health conditions or medical history? </label>
                                </div>
                                <div className="client-medical-form BirthdayWrapper">
                                  <div className="question row">

                                    <div className="col-md-6">
                                      <CustomRadioButton
                                        className="question-radio-btn"
                                        text="Yes"
                                        isblacked={true}
                                        name="medical_condition"
                                        value="yes"
                                        checked={saveMedicalHistoryVal === "yes"}
                                        onChange={(e) =>
                                          handleMedicalHistoryData(e)
                                        }

                                        preselect={true}
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <CustomRadioButton
                                        className="question-radio-btn"
                                        text="No"
                                        value="no"
                                        isblacked={true}
                                        checked={saveMedicalHistoryVal === "no"}
                                        name="medical_condition"
                                        onChange={(e) =>
                                          handleMedicalHistoryData(e)
                                        }
                                        preselect={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {validationErrors.isMedicalHistory && <span ref={medicalHistoryRef} className="error mt-2">{validationErrors.isMedicalHistory}</span>}
                          </div>
                          {/* </div> */}
                        </div>


                        {
                          saveMedicalHistoryVal && (
                            <div className="title-with-content QuestionsList">
                              <div className="questionReview">
                                <div className="questionreviewInside">
                                  <div className="reviewLogo">
                                    <img src={reviewlogo} className="reviewLogo" />
                                  </div>
                                  <div className="reviewContent">
                                    <h5>Please review the questions below</h5>
                                    <p>Provide your responses to complete the form.</p>
                                  </div>
                                </div>
                              </div>

                              {
                                medicalQuestions?.map((mediQue, index) => (
                                  <div className="d-flex justify-content-center align-items-center m-0" key={mediQue?.id}>
                                    <div className="justify-content-between m-0 w-100 ">
                                      <div className="title-with-content">
                                        <label className="form-label"> {mediQue?.question}</label>
                                      </div>
                                      <div className="d-flex">
                                        <div className="client-medical-form BirthdayWrapper w-100">
                                          {
                                            mediQue?.hasSubQuestions && mediQue?.subQuestions?.length > 0 ? (
                                              mediQue?.subQuestions?.map((subque, i) => (
                                                <>
                                                  <div className="subQuestionParent">
                                                    <div className="sub-title-with-content">
                                                      <label className="sub-form-label"> {subque?.question}</label>
                                                    </div>
                                                    <div className="question " key={subque?.id}>
                                                      <div className="my-3 ">
                                                        <CustomRadioButton
                                                          className="question-radio-btn"
                                                          text="Yes"
                                                          isblacked={true}
                                                          name={`sub-medical_condition_${subque?.id}`}

                                                          value="1"
                                                          checked={subque?.answer === 1}
                                                          onChange={() =>
                                                            handleMedicalSubQuestion(index, i,
                                                              {
                                                                answer: 1
                                                              })
                                                          }
                                                          preselect={true}
                                                        />
                                                      </div>
                                                      <div className="my-3">
                                                        <CustomRadioButton
                                                          className="question-radio-btn"
                                                          text="No"
                                                          value="0"
                                                          isblacked={true}
                                                          checked={subque?.answer === 0}
                                                          name={`sub-medical_condition_${subque?.id}`}
                                                          onChange={() =>
                                                            handleMedicalSubQuestion(index, i,
                                                              {
                                                                answer: 0
                                                              })
                                                          }
                                                          preselect={true}
                                                        />
                                                      </div>


                                                    </div>
                                                    <TextInput
                                                      id={`sub-comment_${subque?.id}`}
                                                      placeholder="Add Comment Here"
                                                      // name="firstName"
                                                      value={subque?.comment || ""}
                                                      className={"sub-comment"}
                                                      onFocus={() => handleFocus(`sub-comment_${subque?.id}`)}
                                                      onBlur={handleBlur}
                                                      style={{
                                                        minHeight: isExpanded === `sub-comment_${subque?.id}` ? "100px" : "20px",
                                                        transition: "min-height 0.3s ease",
                                                      }}
                                                      multiline={true}
                                                      rows="5"
                                                      onChange={(e) => handleMedicalSubQuestion(index, i, { comment: e.target.value })}
                                                    />
                                                    {subque.error && <span ref={(el) =>
                                                      (subQuestionRef.current[`${index}-${i}`] = el)
                                                    } className="error">{subque.error}</span>}
                                                  </div>


                                                </>

                                              ))
                                            ) :
                                              (
                                                <>
                                                  <div className="question row">
                                                    <div className="option col-md-6">
                                                      <CustomRadioButton
                                                        className="question-radio-btn"
                                                        text="Yes"
                                                        isblacked={true}
                                                        name={`submedical_condition_${mediQue?.id}`}

                                                        value="1"
                                                        checked={mediQue?.answer === 1}
                                                        onChange={() =>
                                                          handleMedicalRadio(
                                                            index,
                                                            {
                                                              answer: 1
                                                            })
                                                        }
                                                        preselect={true}
                                                      />
                                                    </div>
                                                    <div className="option col-md-6">
                                                      <CustomRadioButton
                                                        className="question-radio-btn"
                                                        text="No"
                                                        value="0"
                                                        isblacked={true}
                                                        checked={mediQue?.answer === 0}
                                                        name={`submedical_condition_${mediQue?.id}`}
                                                        onChange={() =>
                                                          handleMedicalRadio(
                                                            index,
                                                            {
                                                              answer: 0
                                                            })
                                                        }
                                                        preselect={true}
                                                      />
                                                    </div>
                                                  </div>
                                                  <TextInput
                                                    id={`comment_${mediQue?.id}`}
                                                    placeholder="Add Comment Here"
                                                    // name="firstName"
                                                    className={"comment"}
                                                    value={mediQue?.comment || ""}
                                                    onFocus={() => handleFocus(`comment_${mediQue?.id}`)}
                                                    onBlur={handleBlur}
                                                    multiline={true}
                                                    rows="5"
                                                    style={{
                                                      minHeight: isExpanded === `comment_${mediQue?.id}` ? "100px" : "20px",
                                                      transition: "min-height 0.3s ease",
                                                    }}
                                                    onChange={(e) => handleMedicalRadio(index, { comment: e.target.value })}
                                                  />
                                                  {
                                                    console.log("isExpanded", isExpanded)
                                                  }
                                                </>

                                              )
                                          }

                                          {mediQue?.error && <span
                                            ref={(el) => {

                                              questionRef.current[index] = el; // Assign the element ref
                                            }}
                                            className="error">{mediQue?.error}</span>}


                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              }

                            </div>
                          )
                        }
                        <div>
                          <div className="title-with-content" ref={checkRef}>
                            <div className="active-container bg-white">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={checkBoxVal}
                                  name="allCondition"
                                  onChange={(e) => {
                                    handleCheckBoxval(e)
                                  }}
                                  id="1"
                                  disabled={isConfirmedByClient}
                                />
                                <label className="form-label" htmlFor="1">
                                  I confirm the above medical information is accurate to the best of my knowledge and accept responsibility for any errors.
                                </label>
                              </div>
                            </div>
                          </div>
                          {validationErrors.checkBox && <span ref={checkBoxRef} className="error">{validationErrors.checkBox}</span>}
                        </div>

                        <div>
                          <div className="title-with-content cursor-pointer client-signature-wrapper client-signature-wrapper-min-height"
                            onClick={() =>
                              hidePatientSignature()

                            }
                          >

                            <div className="right-section">
                              {
                                patientSigntureData &&
                                <div className="cursor-pointer eraserImg medicalSign " onClick={(event) => {
                                  event.stopPropagation();
                                  paitentClear()
                                }}>
                                  <img src={EraseImg} alt="EraseImg" width={48} height={48} />
                                </div>
                              }

                            </div>
                            <div
                              className="card-section  signatureCardPatient d-flex align-items-center"
                            // onClick={() => 
                            //   hidePatientSignature()

                            // }
                            >
                              <div className="edit-section "></div>
                              <div className="d-flex flex-column align-items-center gap-2 sign-section ">
                                <div className="emptySignSec">
                                  {
                                    patientSigntureData === null ? (
                                      <>
                                        <EmptySignIcon1 />
                                        <h1>Patient Signature</h1>
                                      </>
                                    ) : (
                                      <img src={patientSigntureData} alt="signature" className="signature" />
                                    )
                                  }

                                </div>
                              </div>
                            </div>
                          </div>

                          {
                            validationErrors.clientSignature && <span ref={paitentSignRef} className="error">{validationErrors.clientSignature}</span>
                          }
                        </div>


                        {/* {
                          formToken === null && (
                            <>
                              <div>
                                <div className="title-with-content cursor-pointer client-signature-wrapper"
                                  onClick={() => hidePractitionerSignture()}

                                >
                                  <div className="right-section">
                                    {
                                      practitionerSigntureData &&
                                      <div className="cursor-pointer eraserImg medicalSign" onClick={(event) => {
                                        event.stopPropagation();
                                        PractitionerClear()
                                      }}>
                                        <img src={EraseImg} alt="EraseImg" width={48} height={48} />
                                      </div>
                                    }
                                  </div>

                                  <div
                                    className="card-section  signatureCard d-flex align-items-center"
                                  // onClick={() => hidePractitionerSignture()}
                                  >
                                    <div className="edit-section "></div>
                                    <div className="d-flex flex-column align-items-center gap-2 sign-section ">
                                      <div className="emptySignSec">
                                        {
                                          practitionerSigntureData === null ? (
                                            <>
                                              <EmptySignIcon1 />
                                              <h1>Practitioner Signature</h1>
                                              <div class="noteDesc"><p>Note: This should be the signature of the person performing the treatment</p></div>
                                            </>
                                          ) :
                                            <img src={practitionerSigntureData} alt="signature" className="signature" />
                                        }

                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {
                                  validationErrors.practitionerSignature && <span ref={practitionersignRef} className="error">{validationErrors.practitionerSignature}</span>
                                }
                              </div>
                            </>
                          )
                        } */}

                      </div>
                      <div className={`FooterBtn ${formToken ? 'FooterBtnWithFooter' : ''}`}>
                        {/* <div className={screenWidth < 576 ? "d-none" : ""}>
                          <StepButton
                            label={"Save"}
                            blue={true}
                            isLoading={saveClientMedicalFormDetailQueryData?.loading}
                            onClick={() => handleSubmitMedicalForm()}
                          />
                        </div> */}
                        <StepButton
                          label={"Save"}
                          blue={true}
                          isLoading={saveClientMedicalFormDetailQueryData?.loading}
                          onClick={() => handleSubmitMedicalForm()}
                        />
                        {formToken && <BrandingFooter />}
                      </div>
                    </div>
                  </div>

                </div>

                {
                  fromOffCanvas && <div className="done-btn">
                    <StepButton blue={true} isLoading={createClientMutationData?.loading} label={"Done"}
                    // onClick={() => handleClientAdd()} 
                    />
                  </div>
                }
              </div>

              <CustomModal
                modalOpen={isNoteModal}
                setModalOpen={setIsNoteModal}
                modaltitle={"Add a note"}
                modaltitleCSS={"discount-title"}
                type={"common-width"}
                className={'CustomeAddNoteModel'}
                modalBody={
                  <AddNotes notes={notes} setNotes={setNotes} setIsNoteAdded={setIsNoteAdded} setIsNoteModal={setIsNoteModal} clientId={parseInt(clientId)} />
                }
                setIsOpenMobileCalendar={handleAddCloseClient}
              />
              <OffCanvasModal
                isOpen={isNextOfKin}
                className={fromOffCanvas ? "w-75" : 'CustomeNextOfKin'}
                isBack={true}
                placement={fromOffCanvas ? "end" : "end"}
                isCloseRight={true}
                onHide={() => setIsNextOfKin(false)}
                body={
                  <NextOfKin fromOffCanvas={fromOffCanvas} setIsNextOfKinAdded={setIsNextOfKinAdded} clientDetailsQueryData={commonLoder} clientId={clientId} setNextOfKinData={setNextOfKinData} nextOfKinData={nextOfKinData} setIsNextOfKin={setIsNextOfKin} />
                }
              />
              <OffCanvasModal
                isOpen={showManualAddress}
                isBack={true}
                isCloseRight={true}
                placement={"end"}
                className={fromOffCanvas ? "custom-sidebar-width-30 CustomeAddClientCanvas" : "custom-sidebar-width-25 CustomeAddClientCanvas"}
                onHide={() => setShowManualAddress(false)}
                body={<>
                  <div className="manual-add-container container">
                    <h1>Address</h1>
                    <div className="address-field-container">
                      <TextInput
                        name="address1"
                        label="House No"
                        placeholder="House No"
                        value={location?.address1}
                        onChange={handleLocationChange}
                        pattern="/^[A-Za-z]+$/"

                      />
                      <TextInput
                        name="address2"
                        label="Street Name"
                        placeholder="Street Name"
                        value={location?.address2}
                        onChange={handleLocationChange}

                      />
                      <TextInput
                        name="city"
                        label="City"
                        placeholder="City"
                        value={location?.city}
                        onChange={handleLocationChange}

                      />
                      <TextInput
                        name="postcode"
                        label="Postcode"
                        placeholder="Postcode"
                        pattern={alphaNumericRegexAp.test(location?.postcode)}
                        value={location?.postcode}
                        onChange={handleLocationChange}

                      />

                      <StepButton label={"Done"} blue={true} onClick={() => { handleMenualAddress() }} disabled={
                        location?.address1?.length >= 1 &&
                          location?.address2?.length >= 1 &&
                          location?.city?.length >= 1 &&
                          location?.postcode?.length >= 1
                          ?
                          false
                          : true
                      } />
                    </div>
                  </div>
                </>}

              />

              {/* --------------------------------------------------------------------------------------------------------------------------------- */}
              <OffCanvasModal
                isOpen={showManualPractitionerAddress}
                isBack={true}
                isCloseRight={true}
                placement={"end"}
                className={fromOffCanvas ? "custom-sidebar-width-30 CustomeAddClientCanvas" : "custom-sidebar-width-25 CustomeAddClientCanvas"}
                onHide={() => setShowManualPractitionerAddress(false)}
                body={<>
                  <div className="manual-add-container container">
                    <h1>General practitioners <br /> (GP / Doctors)</h1>
                    <div className="address-field-container">
                      <div>

                        <TextInput
                          name="gpName"
                          label="Name (Optional)"
                          placeholder="Enter Name"
                          value={practitinorModelDetail?.gpName}
                          onChange={(e) => handlePractitioner(e)}
                        // pattern="/^[A-Za-z]+$/"
                        />
                        {practitinorModelError?.gpName && <span className="error">{practitinorModelError?.gpName}</span>}
                      </div>
                      <div>
                        <TextInput
                          name="gpEmail"
                          label="Email address (optional)"
                          placeholder="Enter email address"
                          value={practitinorModelDetail?.gpEmail}
                          onChange={(e) => handlePractitioner(e)}

                        />
                        {practitinorModelError?.gpEmail && <span className="error">{practitinorModelError?.gpEmail}</span>}
                      </div>
                      <div>
                        <TextInput
                          name="gpAddress"
                          label="Address (optional)"
                          placeholder="Enter Address"
                          value={practitinorModelDetail?.gpAddress}
                          onChange={(e) => handlePractitioner(e)}

                        />
                      </div>

                      <div>
                        <div className="row email-section">
                          <p className="m-0">Phone number</p>
                          <div className="col-5 col-sm-4 mt-2 ps-0 ps-md-3">
                            <CountrySelect labels={{ 'ZZ': 'Select Country' }} value={practitinorModelDetail?.gpCountryCode} onChange={(e) => handleCountryChange(e)} />
                          </div>
                          <div className="col-7 col-sm-8 mt-2 pe-0 pe-md-3">
                            <TextInput
                              name="gpMobile"
                              value={practitinorModelDetail?.gpMobile}
                              onChange={(e) => handlePractitioner(e)}
                              placeholder="Enter phone number"
                            />

                          </div>
                        </div>
                        {practitinorModelError?.gpMobile && <span className="error">{practitinorModelError?.gpMobile}</span>}
                      </div>

                      <StepButton label={"Done"} blue={true} onClick={() => { handlePractitionersAddress() }}
                      />
                    </div>
                  </div>
                </>}

              />
              {
                isPatientSignatureOpen && (
                  <CustomModal
                    className={'CustomeSignModel ModelMaxWidth540'}
                    modalOpen={isPatientSignatureOpen}
                    setIsOpenMobileCalendar={setIsPatientSignatureOpen}
                    setModalOpen={handlePatientSignture}
                    modaltitle={"Patient signature"}
                    type="common-width"
                    modalBody={
                      <div className="d-flex flex-column wrapper-canvas">
                        {!patientPreviewDataUrl ? (
                          <SignatureCanvas
                            clearOnResize={false}
                            ref={patientSignRef}
                            canvasProps={{
                              width: 500,
                              height: 200,
                              className: 'signCanvas',
                            }}
                            penColor="black"
                            throttle={null}
                            onEnd={() => {
                              setIsPatientSigned(false);
                              setPatientToggleSigned(true);
                              setPatientTrimmedDataUrl(
                                patientSignRef?.current
                                  ?.getTrimmedCanvas()
                                  .toDataURL('image/png')
                              );
                            }}
                          />
                        ) : (
                          <img
                            src={patientPreviewDataUrl}
                            style={{
                              objectFit: 'none',
                              height: 200,
                              width: 500,
                            }}
                          />
                        )}
                        <div className="justify-content-between d-flex w-100">
                          {
                            patientPreviewDataUrl && (
                              <>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => paitentClear()}
                                >
                                  <img
                                    src={EraseImg}
                                    alt="EraseImg"
                                    width={48}
                                    height={48}
                                  />
                                </div>
                              </>
                            )


                          }
                          {patientPreviewDataUrl || patientTrimmedDataUrl ? (
                            <UndoEnableIcon
                              style={
                                !patientPreviewDataUrl
                                  ? { cursor: 'pointer' }
                                  : { visibility: 'hidden' }
                              }
                              onClick={() => paitentClear()}
                            />
                          ) : (
                            <UndoIcon
                              style={
                                !patientPreviewDataUrl
                                  ? { cursor: 'not-allowed' }
                                  : { visibility: 'hidden' }
                              }
                            />
                          )}
                          {
                            <EnableCheck
                              onClick={() => {
                                handlePaitentSigntureModelClose();
                                setIsPatientSignatureOpen(false);
                                setPatientToggleSigned(true);

                                if (patientTrimmedDataUrl) {


                                  setPatientSigntureData(
                                    patientTrimmedDataUrl
                                  );
                                } else if (patientPreviewDataUrl) {
                                  setPatientSigntureData(
                                    patientPreviewDataUrl
                                  );
                                } else {
                                  setPatientSigntureData(null);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          }
                        </div>
                      </div>
                    }
                  />
                )
              }

              {
                isPractitionerSignatureOpen && (
                  <CustomModal
                    className={'CustomeSignModel ModelMaxWidth540'}
                    modalOpen={isPractitionerSignatureOpen}
                    setIsOpenMobileCalendar={setIsPractitionerSignatureOpen}
                    setModalOpen={handlePractitionerSignture}
                    modaltitle={"Practitioner signature"}
                    type="common-width"
                    modalBody={
                      <div className="d-flex flex-column wrapper-canvas">
                        {!practitionerPreviewDataUrl ? (
                          <SignatureCanvas
                            clearOnResize={false}
                            ref={practitionerSignRef}
                            canvasProps={{
                              width: 500,
                              height: 200,
                              className: 'signCanvas',
                            }}
                            penColor="black"
                            throttle={null}
                            onEnd={() => {
                              setIsPractitionerSigned(false);
                              setPractitionerToggleSigned(true);
                              setPractitionerTrimmedDataUrl(
                                practitionerSignRef?.current
                                  ?.getTrimmedCanvas()
                                  .toDataURL('image/png')
                              );
                            }}
                          />
                        ) : (
                          <img
                            src={practitionerPreviewDataUrl}
                            style={{
                              objectFit: 'none',
                              height: 200,
                              width: 500,
                            }}
                          />
                        )}
                        <div className="justify-content-between d-flex w-100">
                          {
                            practitionerPreviewDataUrl && (
                              <>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => PractitionerClear()}
                                >
                                  <img
                                    src={EraseImg}
                                    alt="EraseImg"
                                    width={48}
                                    height={48}
                                  />
                                </div>
                              </>
                            )


                          }
                          {practitionerPreviewDataUrl || practitionerTrimmedDataUrl ? (
                            <UndoEnableIcon
                              style={
                                !practitionerPreviewDataUrl
                                  ? { cursor: 'pointer' }
                                  : { visibility: 'hidden' }
                              }
                              onClick={() => PractitionerClear()}
                            />
                          ) : (
                            <UndoIcon
                              style={
                                !practitionerPreviewDataUrl
                                  ? { cursor: 'not-allowed' }
                                  : { visibility: 'hidden' }
                              }
                            />
                          )}
                          {
                            <EnableCheck
                              onClick={() => {
                                handlePractitionerSignModelClose();
                                setIsPractitionerSignatureOpen(false);
                                setPractitionerToggleSigned(true);

                                if (practitionerTrimmedDataUrl) {
                                  setPractitionerSigntureData(
                                    practitionerTrimmedDataUrl
                                  );
                                } else if (practitionerPreviewDataUrl) {
                                  setPractitionerSigntureData(
                                    practitionerPreviewDataUrl
                                  );
                                } else {
                                  setPractitionerSigntureData(null);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          }
                        </div>
                      </div>
                    }
                  />
                )
              }
            </div>
          </div>
        )
      }

      {
        step == 2 && formToken && (
          <ForwardedMedicalThankYou />
        )
      }
    </>);
};

export default MedicalForm;